import { useContext } from "react";
import { NumberOfferContext } from "../../../App";
import { ICart, IPortin } from "../ICart";
import { getStateToPayload } from "../mappers/updatePortinMapper";
import { getResponseToState, ICartResponse } from "@mappers/getCartMapper";
import { useFetch } from "@hooks/useFetch";
import { portinRoute } from "@api-routes/eirSalesFacade";
import { getCartItemsNumber } from "@utils/getCartItemsNumber";

export const useAddPortin = () => {
    const [addPortinState, { post }] = useFetch();
    const { setNumberOfferSelected } = useContext(NumberOfferContext);

    const addPortin = (cartOfferId: number, portinForm: IPortin): Promise<ICart | undefined> =>
        post<ICartResponse>(portinRoute(cartOfferId), {
            body: getStateToPayload(portinForm),
        }).then((newCartResponse) => {
            if (newCartResponse) {
                const newCart = getResponseToState(newCartResponse);

                setNumberOfferSelected(getCartItemsNumber(newCart));

                return newCart;
            }

            return undefined;
        });

    return { addPortinState, addPortin };
};
